import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Footer } from '@/components/layout/Footer'
import { ArrowLeft } from 'lucide-react'

export function TermsOfService() {
  const { t } = useTranslation()
  const lastUpdated = new Date().toLocaleDateString(
    t('common.loading') === 'Loading...' ? 'en-US' : 'pt-BR',
    { year: 'numeric', month: 'long', day: 'numeric' }
  )

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-primary-700 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-lg">FJ</span>
            </div>
            <div>
              <h1 className="text-lg font-bold text-slate-900">Flight Journal</h1>
            </div>
          </div>
          <Link
            to="/"
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            {t('common.back')}
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 py-12">
        <div className="max-w-4xl mx-auto px-4">
          <div className="bg-white rounded-lg shadow-sm border border-slate-200 p-8 md:p-12">
            <h1 className="text-4xl font-bold text-slate-900 mb-2">
              {t('legal.terms.title')}
            </h1>
            <p className="text-sm text-slate-500 mb-8">
              {t('legal.terms.lastUpdated', { date: lastUpdated })}
            </p>

            <div className="prose prose-slate max-w-none">
              <p className="text-lg text-slate-700 mb-8">
                {t('legal.terms.intro')}
              </p>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-slate-900 mb-4">
                  {t('legal.terms.acceptance.title')}
                </h2>
                <p className="text-slate-700">
                  {t('legal.terms.acceptance.description')}
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-slate-900 mb-4">
                  {t('legal.terms.use.title')}
                </h2>
                <p className="text-slate-700 mb-4">
                  {t('legal.terms.use.description')}
                </p>
                <ul className="list-disc pl-6 space-y-2 text-slate-700">
                  <li>{t('legal.terms.use.items.regulations')}</li>
                  <li>{t('legal.terms.use.items.laws')}</li>
                  <li>{t('legal.terms.use.items.rights')}</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-slate-900 mb-4">
                  {t('legal.terms.accounts.title')}
                </h2>
                <p className="text-slate-700">
                  {t('legal.terms.accounts.description')}
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-slate-900 mb-4">
                  {t('legal.terms.data.title')}
                </h2>
                <p className="text-slate-700">
                  {t('legal.terms.data.description')}
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-slate-900 mb-4">
                  {t('legal.terms.liability.title')}
                </h2>
                <p className="text-slate-700">
                  {t('legal.terms.liability.description')}
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-slate-900 mb-4">
                  {t('legal.terms.termination.title')}
                </h2>
                <p className="text-slate-700">
                  {t('legal.terms.termination.description')}
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-slate-900 mb-4">
                  {t('legal.terms.governing.title')}
                </h2>
                <p className="text-slate-700">
                  {t('legal.terms.governing.description')}
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-slate-900 mb-4">
                  {t('legal.terms.contact.title')}
                </h2>
                <p className="text-slate-700 mb-2">
                  {t('legal.terms.contact.description')}
                </p>
                <p className="text-slate-700">
                  <strong>{t('footer.contact')}:</strong>{' '}
                  <a
                    href="mailto:acmh360@gmail.com"
                    className="text-primary-700 hover:text-primary-800 underline"
                  >
                    {t('legal.terms.contact.email')}
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}
